import { createFileRoute } from "@tanstack/react-router";
import { Navigate } from "@tanstack/react-router";
import { z } from "zod";
import { OrganizationHeader } from "@/components/organizations/OrganizationHeader";
import { OrganizationStats } from "@/components/organizations/OrganizationStats";
import { OrganizationListing } from "@/components/organizations/OrganizationListing";
import { useAuth } from "@/hooks/useAuth";
import { useIsTablet } from "@/hooks/use-mobile";
import { PageHeader } from "@/components/layout/PageHeaderSlot";
import { Trans } from "@lingui/react/macro";

const organizationsSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  status: z.enum(["all", "active", "inactive"]).catch("all"),
});

export const Route = createFileRoute("/(protected)/_layout/organizations")({
  validateSearch: (search) => organizationsSearchSchema.parse(search),
  component: OrganizationsPage,
});

function OrganizationsPage() {
  const isTablet = useIsTablet();
  const { hasRole, isLoading } = useAuth();
  const isInternalAdmin = hasRole("SUPER_ADMIN") || hasRole("SUPPORT");

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center p-8">
        <div className="text-(--color-text-secondary)">
          <Trans>Loading...</Trans>
        </div>
      </div>
    );
  }

  if (!isInternalAdmin) {
    return (
      <Navigate
        to="/unauthorized"
        search={{ reason: "internal_only", from: "/organizations", requiredRole: "SUPER_ADMIN|SUPPORT" }}
        replace
      />
    );
  }

  return (
    <div className="flex flex-col gap-5 py-5 px-3">
      {isTablet ? (
        <PageHeader>
          <OrganizationHeader tablet />
        </PageHeader>
      ) : (
        <OrganizationHeader />
      )}
      <OrganizationStats />
      <OrganizationListing />
    </div>
  );
}
